import { useCallback } from 'react'
import { PdfConfigTemplateSingleTy } from '../../../../types'
import { PdfConfigTemplateTabProps } from '../../../types'
import ModalDeleteFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { addAntiUnsaveElement } from '../../../../../../../../../../utils/reducers/reduxDispatch'

interface CPTDeleteModalProps extends CPTDeleteModalLogicProps { }

const CPTDeleteModal: React.FC<CPTDeleteModalProps> = ({ setOpenModal, ...rest}) => {
    const { removeElement } = useCPTDeleteModalLogic({ ...rest, setOpenModal })
    const {t} = useTwinTranslation()
    return (
        <ModalDeleteFilled opened={true} setOpened={() => setOpenModal(null)} onCancel={() => setOpenModal(null)} onAccept={removeElement} translations={{
            title: t('sureDeleteElement', '¿Seguro que quieres eliminar este elemento?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

interface CPTDeleteModalLogicProps extends PdfConfigTemplateTabProps {
    removeIn: number
}

const useCPTDeleteModalLogic = ({setConfig, openModal, removeIn}: CPTDeleteModalLogicProps) => {
    const removeElement = useCallback(async () => {
        await addAntiUnsaveElement(['pdf_template_changes', '{}'])
        const splitKey = String(removeIn).split(',')
        const myPageKey = splitKey[0]
        const mySectionKey = splitKey[1]
        if (openModal?.allRowData?.subKey !== undefined) {
            setConfig((old) => {
                const copy: PdfConfigTemplateSingleTy = JSON.parse(JSON.stringify(old))
                copy.pages[parseInt(myPageKey)].sections[parseInt(mySectionKey)].elements.splice(openModal?.allRowData?.subKey, 1)
                return { ...copy }
            })
        }

    }, [setConfig, openModal, removeIn])
    return { removeElement }
}

export default CPTDeleteModal